export default __webpack_public_path__ + "static/media/maisons_laffitte14.10554563.jpg";